<template>
    <div class="uk-grid-medium uk-child-width-1-1"
         uk-grid>
        <!-- Shop -->
        <shop-products @load-page="loadPage"
                       @buy-shop-item="buy"
                       :shop-items="page.ShopItems"
                       :shop-item-prices="page.ShopItemPrices"
                       :shop-order-items="page.ShopOrderItems">
        </shop-products>
        <loading :show="true"
                label="">
            <template slot="loading-spinner">
                <div uk-spinner="ratio: 2"></div>
            </template>
        </loading>
    </div>
</template>

<script>
    import ShopProducts from "../ShopProducts";
    import ShopProductsMixin from './../ShopProductsMixin'
    import Loading from "vue-full-loading";

    export default {
        name: "SearchShopItems",
        components: {Loading, ShopProducts},
        mixins: [ShopProductsMixin],
        props: {
            result: {
                type: Object,
                required: true
            },
        },
        created() {
            this.loadPage(1);
        },
        data() {
            return {
                page: {
                    ShopItems: {},
                    ShopItemPrices: [],

                },
                params: {
                    page: 1,
                    indexName: this.result.indexName,
                    query: this.result.query
                }
            }
        },
        methods: {
            loadPage(page) {
                this.params.page = page;
                this.fetchShopItems('/search/results', this.params, false);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SearchShopItems.vue?cfc2e39c